e4.bootstrap.carousel = {
    init: function () {
        e4.bootstrap.carousel.bindEvents();
    },
    bindEvents: function () {
        jQuery( document ).on( 'keydown', function ( event ) {
            jQuery( '.carousel' ).each( function ( intIndex, domNode ) {
                var jCarousel = jQuery( domNode );
                if ( e4.util.isInViewport( jCarousel ) === true ) {
                    if ( jCarousel.data( 'keyboard' ) !== false && /input|textarea/i.test( event.target.tagName ) === false ) {
                        if ( event.which === 37 ) {
                            jCarousel.carousel( 'prev' );
                        }
                        else if ( event.which === 37 ) {
                            jCarousel.carousel( 'next' );
                        }
                    }
                }
            } );
        } );
    }
};

